import { COLORS } from "@tSurya/theme/design";

export default {
    primary: {
        main: COLORS.primary.base, // #323132
        contrast: COLORS.primary.contrast, // #ffffff
    },
    secondary: {
        main: COLORS.secondary.base, // #F4F3F1
        contrast: COLORS.white, // #ffffff
    },
    accent: {
        main: COLORS.accent.main, // #866A5B
        contrast: COLORS.accent.contrast, // #FFFFFF
    },
    background: {
        main: COLORS.background.main, // #ffffff
        contrast: COLORS.background.contrast, // #0E0E0E
    },
    border: COLORS.border.main, // #E1DDE2
    disabled: COLORS.disabled.main, // #E5E5E5
    info: {
        main: COLORS.info.main, // #1C355E
        contrast: COLORS.info.contrast, // #FFFFFF
    },
    success: {
        main: COLORS.success, // #33864F
        contrast: COLORS.white, // #ffffff
    },
    danger: {
        main: COLORS.error, // #BE3445
        contrast: COLORS.white, // #ffffff
    },
    warning: {
        main: COLORS.warning, // #EF9600
        contrast: COLORS.white, // #ffffff
    },
    text: {
        main: COLORS.text.main, // #333333
        accent: COLORS.text.accent, // #323132
        disabled: COLORS.text.disabled, // #C5C5C7
        link: COLORS.text.link, // #866A5B
    },
};
